import { reviver } from './reviver';
import { replacer } from './replacer';
const json = {
    reviver,
    replacer,
};
export { json };
